<!--
 Компонент отзывов, отличается от v1 золотыми звездами
 @usages: pp1 screen
 props:
  review - id ключа отзыва из переменной ReviewsList
  theme - тема шаблона темпная или светлая
-->
<template>
  <div
    :key="review"
    class="review"
    :class="[theme]"
  >
    <div class="review__tob-block">
      <div class="review__top">
        <h3 class="review__title paragraph_14-700">
          {{ $t(reviewsList[review].title) }}
        </h3>
        <span class="review-name paragraph-12-500">
          {{ reviewsList[review].name }}
        </span>
      </div>
      <div class="review__rating">
        <nuxt-icon
          v-for="i of reviewsList[review].rating"
          :key="i"
          name="yellow-stars"
          filled
        />
      </div>
    </div>
    <p class="review__text paragraph-12-500">
      {{ $t(reviewsList[review].text) }}
    </p>
  </div>
</template>

<script setup lang="ts">
const { reviewsList } = useAppConfig().reviewsConfigs;

defineProps({
  review: {
    type: Number,
    required: true,
  },
  theme: {
    type: String,
    default: 'light',
    validator(type: string): boolean {
      return ['light', 'dark'].includes(type);
    },
  },
});
</script>

<style lang="scss" scoped>
.review {
  padding: 16px;
  margin-top: 8px;
  border-radius: 9px;

  &.light {
    background: $neutral;

    & .review__title {
      color: $text-color;
    }

    & .review__text {
      font-weight: 400;
    }
  }

  &__rating {
    display: flex;
    align-content: center;
  }

  &__top {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    margin-bottom: 4px;
  }

  &__title {
    font-size: 14px;
    font-style: normal;
    font-weight: 700 !important;
    line-height: 150% !important;
    flex: 1;
  }

  &__tob-block {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;

    .review-name {
      text-align: right;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 175%; /* 18px */
      opacity: 0.5;
    }
  }
}
</style>
